<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline">{{ t('notice.title') }}</h1>
        <template v-if="Array.isArray(notices) && notices.length">
          <ul class="card-outlined pt-3 px-3 md:pt-4 md:px-4">
            <li v-for="notice in pagedList" :key="notice.id" class="pb-3 md:pb-4">
              <router-link
                :to="`/notice/${notice.id}`"
                class="text-link"
              >
                <div class="flex text-sm md:text-base">
                  <div class="leading-tight pr-3">{{ dayjs(notice.published_at).format('YYYY/MM/DD') }} </div>
                  <div class="leading-tight">{{ notice.title }}</div>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="flex items-center justify-center mt-10">
            <base-pagination v-model:pagedList="pagedList" :originalList="notices" :pageSize="pageSize" />
          </div>
        </template>
        <template v-else>
          お知らせが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { dayjs } from '@/plugins/dayjs'
import { NoticeAttributes } from '@/types/models/notice'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BasePagination from '@/components/BasePagination.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BasePagination
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const notices = computed(() => store.state.notice.notices)
    const pageSize = ref(10)
    const pagedList = ref<NoticeAttributes[]>([])

    onMounted(() => {
      store.dispatch('notice/fetchNotices')
    })

    return {
      t,
      dayjs,
      store,
      notices,
      pageSize,
      pagedList
    }
  }
})
</script>
